import React, { useContext } from 'react'


export const ManagerContext = React.createContext<ReactDnD.Manager>(null)

export const ManagerProvider = ManagerContext.Provider

export const useManagerContext = () => useContext(ManagerContext)
